var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0527344,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#FFB9C5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_18872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.284 10.9441V9.80859H16.7032V10.9441H15.284ZM15.284 22.1912V21.0517H16.7032V22.1912H15.284ZM12.4148 10.9441V9.80859H13.834V10.9441H12.4148ZM12.4148 22.1912V21.0517H13.834V22.1912H12.4148ZM9.80859 10.9441V9.80859H10.9481V10.9441H9.80859ZM9.80859 13.83V12.4108H10.9481V13.83H9.80859ZM9.80859 16.7159V15.2966H10.9481V16.7159H9.80859ZM9.80859 19.5851V18.1659H10.9481V19.5851H9.80859ZM9.80859 22.1912V21.0517H10.9481V22.1912H9.80859ZM18.1698 22.1912V21.0517H19.6024V10.9441H18.1698V9.80859H22.1912V10.9441H20.7419V21.0517H22.1912V22.1912H18.1698Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_18872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8.05273 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextArea);
export default __webpack_public_path__ + "static/media/textArea.4417b78c41b3f5f17138b7efcee3a8d7.svg";
export { ForwardRef as ReactComponent };